export function Stack({
  children,
  spacing = 'md',
  className,
}: {
  children: React.ReactNode
  className?: string
  spacing?: 'flush' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
}) {
  const findSpacing = () => {
    switch (spacing) {
      case 'flush':
        return 'gap-0'
      case 'xs':
        return 'gap-2'
      case 'sm':
        return 'gap-4'
      case 'md':
        return 'gap-8'
      case 'lg':
        return 'gap-10'
      case 'xl':
        return 'gap-12'
      case '2xl':
        return 'gap-14'

      default:
        return 'gap-8'
    }
  }
  const space = findSpacing()
  return (
    <div className={`${className} flex flex-col ${space} w-full`}>
      {children}
    </div>
  )
}
